<template>
  <div v-show="showToolbar">
    <div
      v-show="showToolbar"
      class="element-toolbar-component"
      :style="handleToolbarStyle"
      :class="{ dragging: isDragging }"
    >
      <p
        v-if="USER_ROLE_NAME[Number(userInfo.UserRole)] !== 'student'"
        class="role-wrap"
      >
        {{ USER_ROLE[Number(userInfo.UserRole)] }}
      </p>
      <p class="user-name">{{ userInfo.nick }}</p>
    </div>
    <TextStyleSelector
      v-if="showTextStyleSelector"
      ref="textStyleSelector"
      :style="handleTextPositionStyle"
      :element="selectElements[0]"
      @change="handleChangeTextStyle"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import TextStyleSelector from "../toolbar-dialog/TextStyleSelector.vue";
export const USER_ROLE = {
  1: "教师",
  2: "助教",
  3: "学生",
};
export const USER_ROLE_NAME = {
  1: "teacher",
  2: "assistant",
  3: "student",
};

export default {
  name: "ElementToolbar",
  components: { TextStyleSelector },
  data() {
    return {
      toolbarHeight: 20, // 工具栏高度
      showToolbar: false, // 工具栏显示状态
      boxArea: {},
      selectElements: [],
      userInfo: {},
      USER_ROLE,
      USER_ROLE_NAME,
      showTextStyleSelector: false,
      isDragging: false, // 拖动状态
    };
  },
  mounted() {
    this.whiteBoardService.on("showToolbar", ({ res, status }) => {
      this.selectElements = res?.selectElements || [];
      if (res?.userId) {
        if (this.userInfo?.userID !== res?.userId) {
          if (this.imService) {
            this.imService
              .getGroupMemberProfile({ userIDList: [res?.userId] })
              .then((res) => {
                this.userInfo = res[0] || {};
              });
          } else if (this.isHXApp) {
            this.$jsToFlutter("getGroupMemberProfile", {
              userIDList: [res?.userId],
            });
          }
        }
        this.showToolbar = true;
        if (res?.boxArea) {
          this.boxArea = res?.boxArea;
        }
      } else {
        this.showToolbar = false;
      }
      if (this.selectElements.length && this.selectElements.length === 1) {
        const element = this.selectElements[0];
        const res = this.whiteBoardService.isTextElement(element);
        this.showTextStyleSelector = res;
      } else {
        this.showTextStyleSelector = false;
      }
      if (status === 1) {
        this.isDragging = true;
      } else if (status === 2) {
        this.isDragging = false;
      }
    });
    this.whiteBoardService.on("removeElement", (ids) => {
      console.log("==99removeElement", ids);
      this.showToolbar = false;
    });
    // 移除键盘事件监听
    window.removeEventListener("keydown", this.handleKeyDown);
    // 添加键盘事件监听
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeDestroy() {},
  methods: {
    handleKeyDown(event) {
      // 当按下 delete 键且有选中元素时，执行删除操作
      if (event.key === "Delete" && this.selectElements.length > 0) {
        this.whiteBoardService.removeElement(this.selectElements);
      }
    },
    handleChangeTextStyle(params) {
      const { type, value } = params;
      if (type === "size") {
        const elementId = this.selectElements[0].elementId;
        this.whiteBoardService.updateElementTextSize({
          elementId,
          value: value,
        });
        // 字体大小改变后，等待白板更新完成再重新获取元素的边界信息
        setTimeout(() => {
          this.updateElementBounds(
            this.whiteBoardService.getElementById(elementId)
          );
        }, 50);
      } else {
        this.whiteBoardService.updateElementTextColor({
          elementId: this.selectElements[0].elementId,
          value: value,
        });
      }
    },
    // 更新元素边界信息
    updateElementBounds(element) {
      if (this.selectElements.length === 1) {
        // 重新计算边界信息
        const boxArea = {
          minX: element.boundingbox.left,
          minY: element.boundingbox.top,
          maxX: element.boundingbox.left + element.boundingbox.width,
          maxY: element.boundingbox.top + element.boundingbox.height,
        };
        this.boxArea = boxArea;
      }
    },
  },
  watch: {
    eleToolbarUserInfo: {
      handler(newVal) {
        if (newVal?.userID) {
          this.userInfo = newVal;
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("live", ["whiteBoardService", "imService", "isHXApp"]),
    ...mapState("whiteBoard", ["eleToolbarUserInfo"]),
    handleToolbarStyle() {
      if (this.boxArea) {
        const { minY, minX, maxY } = this.boxArea || {};
        if (minY > this.toolbarHeight + 8) {
          return {
            top: minY - this.toolbarHeight - 8 + "px",
            left: minX + "px",
          };
        } else {
          const whiteBoardHeight = document.querySelector(
            "#comp-container__white-board-sketch"
          )?.clientHeight;
          const top = maxY + 8;
          if (top > whiteBoardHeight - 40) {
            return {
              top: whiteBoardHeight - 40 + "px",
              left: minX + "px",
            };
          } else {
            return {
              top: maxY + 8 + "px",
              left: minX + "px",
            };
          }
        }
      } else {
        return {};
      }
    },
    handleTextPositionStyle() {
      if (!this.boxArea) return {};
      const { maxX, maxY, minX } = this.boxArea;
      const textWidth = 167; // 估算宽度，可根据实际调整
      const defaultTextHeight = 150; // 估算高度
      const padding = 2;
      const winW = window.innerWidth;
      const winH = window.innerHeight;

      // 获取白板容器的偏移
      const board = document.querySelector(
        "#comp-container__white-board-sketch"
      );
      const boardRect = board
        ? board.getBoundingClientRect()
        : { left: 0, top: 0 };

      // 动态获取弹窗实际高度
      let popupHeight = defaultTextHeight;
      // if (this.$refs.textStyleSelector && this.$refs.textStyleSelector.$el) {
      //   popupHeight =
      //     this.$refs.textStyleSelector.$el.offsetHeight || defaultTextHeight;
      // }

      // 计算 left
      let left;
      if (boardRect.left + maxX + textWidth + padding < winW) {
        // 右侧能放下
        left = boardRect.left + maxX + padding;
      } else {
        // 右侧放不下，贴左侧
        left = boardRect.left + minX - 80 - padding;
        if (left < padding) left = padding;
      }

      // 计算 top
      let top;
      if (boardRect.top + maxY + popupHeight + padding < winH) {
        // 下方能放下
        top = boardRect.top + maxY + padding;
      } else {
        // 下方放不下，贴窗口底部
        top = winH - popupHeight - padding;
        if (top < padding) top = padding;
      }

      return {
        position: "fixed",
        left: left + "px",
        top: top + "px",
        zIndex: 900,
        ...(this.isDragging ? { pointerEvents: "none" } : {}),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.element-toolbar-component {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;

  // 拖动状态下的样式
  &.dragging {
    pointer-events: none !important;
    opacity: 0.6;
    transition: opacity 0.2s ease;
  }

  .role-wrap {
    height: 20px;
    background: #e8faf0;
    border-radius: 6px 6px 6px 6px;
    padding: 0 3px;
    font-weight: 500;
    font-size: 12px;
    color: #17c964;
    line-height: 1;
    margin-right: 4px;
    display: flex;
    align-items: center;
  }
  .user-name {
    font-weight: 500;
    font-size: 12px;
    color: #000000;
    line-height: 1;
  }
}
</style>
